import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import apex, { getApex } from '../../apex';
import { getInactiveOrders, getAccountTrades, getOrders, getOpenOrders, getOpenTradeReports, initOrderHistorySubscription, subscribeToOrderHistory } from './orderHistoryActions';
import { marginAccountSelector } from '../selectors/marginSelectors';
import { getDepositTickets } from './depositActions';
import { getAccountVerificationLevelConfig, getWithdrawTickets, subscribeToWithdrawalTickets } from './withdrawActions';
import { changeLanguage } from './languageActions';
import { showSnack } from './snackbarActions';
import { MODAL_TYPES, closeModal } from './modalActions';
import { formatErrorText } from '../../helpers/errorTextFormatter';
import { subscribeToVerificationLevelUpdateEvents } from './kycActions';
import { getTransfers, getIncomingTransfers } from './transferActions';
import { getTransferRequestsReceived, getTransferRequestsRequested } from './transferRequestActions';
import { getAffiliate } from '../actions/affiliateActions';
import { getAccountPositions, subscribeToAccountPositionEvents } from './positionActions';
import { subscribeToDeposits } from './depositActions';
import { initMarketTradeSubscription, subscribeToMarketTradeUpdated } from './marketStateUpdateActions';
import { subscribeToAccountSettlements } from './eotcSettlementActions';
import { receiveMarginAccountPositionEvent, subscribeToMarginAccountPositionEvents, getMarginAccountState } from './marginActions';
import { logout, authSuccess } from './authActions';
import { getOperatorLoyaltyFeeConfigs } from './loyaltyFeeActions';
import { change } from 'redux-form';
import { updateAccount as UpdateAccount } from './kycActions';
import AccountEventsSubscriptionService from '../../services/subscriptions/AccountEventsSubscriptionService';
import config from '../../config';
export var USER_INFO_FETCHED = 'USER_INFO_FETCHED';
export var USER_CONFIG_FETCHED = 'USER_CONFIG_FETCHED';
export var RECEIVE_USER_PERMISSIONS = 'RECEIVE_USER_PERMISSIONS';
export var RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT';
export var SET_ACCOUNT = 'SET_ACCOUNT';
export var RECEIVE_KYC = 'RECEIVE_KYC';
export var UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export var SET_GOOGLE_QRCODE = 'SET_GOOGLE_QRCODE';
export var CLEAR_GOOGLE_QRCODE = 'CLEAR_GOOGLE_QRCODE';
export var userInfoFetched = function userInfoFetched(payload) {
  return {
    type: USER_INFO_FETCHED,
    payload: payload
  };
};
export var setUserInfo = function setUserInfo(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var userInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(callAPI('SetUserInfo', {
                UserName: payload.username,
                Email: payload.email
              }));
            case 2:
              userInfo = _context.sent;
              if (userInfo.result !== false) {
                dispatch(userInfoFetched(userInfo));
                dispatch(changeLanguage(payload.language));
              } else {
                dispatch(showSnack({
                  id: 'setUserInfoError',
                  text: formatErrorText(userInfo),
                  type: 'warning'
                }));
              }
            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getUserInfo = function getUserInfo(UserId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var userInfo;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(callAPI('GetUserInfo', {
                UserId: UserId
              })).catch(function (e) {
                console.error('getUserInfo action error', e);
                return;
              });
            case 2:
              userInfo = _context2.sent;
              dispatch(userInfoFetched(userInfo));
              dispatch(getUserPermissions(userInfo.UserId));
              dispatch(getUserAccounts(userInfo.OMSId));
              dispatch(getUserConfig(userInfo.UserId, userInfo.UserName));
              dispatch(selectAccount(userInfo.AccountId, userInfo.OMSId));
              dispatch(getAffiliate(userInfo.OMSId, userInfo.UserId));
              dispatch(getOperatorLoyaltyFeeConfigs(userInfo.OMSId));
              return _context2.abrupt('return', userInfo);
            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var userConfigFetched = function userConfigFetched(payload) {
  return {
    type: USER_CONFIG_FETCHED,
    payload: payload
  };
};
export var getUserConfig = function getUserConfig(UserId, UserName) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var userConfig;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              userConfig = void 0;
              _context3.next = 3;
              return dispatch(callAPI('GetUserConfig', {
                UserId: UserId,
                UserName: UserName
              })).catch(function (e) {
                console.error('getUserConfig action error', e);
                return;
              });
            case 3:
              userConfig = _context3.sent;
              dispatch(userConfigFetched(userConfig));
              return _context3.abrupt('return', userConfig);
            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/**
 * Merge `config` arg with existing user config
 */
export var updateUserConfig = function updateUserConfig(config) {
  return function (dispatch, getState) {
    var mergedConfig = [].concat(_toConsumableArray(getState().user.userConfig));
    config.forEach(function (current) {
      var index = mergedConfig.findIndex(function (i) {
        return i.Key === current.Key;
      });
      if (index !== -1) {
        mergedConfig[index] = current;
      } else {
        mergedConfig.push(current);
      }
    });
    dispatch(userConfigFetched(mergedConfig));
  };
};
export var setUserConfig = function setUserConfig(UserId, UserName, Config) {
  var getUserConfigAfterSetUserConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var _getState, _getState$user, userInfo, userConfig;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _getState = getState(), _getState$user = _getState.user;
              _getState$user = _getState$user === undefined ? {} : _getState$user;
              userInfo = _getState$user.userInfo;
              _context4.next = 5;
              return dispatch(callAPI('SetUserConfig', {
                UserId: UserId || userInfo.UserId,
                UserName: UserName || userInfo.UserName,
                Config: Config
              }));
            case 5:
              userConfig = _context4.sent;
              if (userConfig.result !== false) {
                if (getUserConfigAfterSetUserConfig) dispatch(getUserConfig(UserId, UserName));
              } else {
                dispatch(showSnack({
                  id: 'setUserConfigError',
                  text: formatErrorText(userConfig),
                  type: 'warning'
                }));
              }
              return _context4.abrupt('return', userConfig);
            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var getUserPermissions = function getUserPermissions(UserId) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var permissions;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return dispatch(callAPI('GetUserPermissions', {
                UserId: UserId
              }));
            case 2:
              permissions = _context5.sent;
              dispatch(receiveUserPermissions(permissions));
            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));
    return function (_x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var receiveUserPermissions = function receiveUserPermissions(payload) {
  return {
    type: RECEIVE_USER_PERMISSIONS,
    payload: payload
  };
};
export var getUserAccounts = function getUserAccounts(OMSId) {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var userAccountIds, accountInfoArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, accountId, accountInfo;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return dispatch(callAPI('GetUserAccounts', {
                OMSId: OMSId
              }));
            case 2:
              userAccountIds = _context6.sent;
              accountInfoArray = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context6.prev = 7;
              _iterator = userAccountIds[Symbol.iterator]();
            case 9:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context6.next = 19;
                break;
              }
              accountId = _step.value;
              _context6.next = 13;
              return dispatch(callAPI('GetAccountInfo', {
                AccountId: accountId,
                OMSId: OMSId
              }));
            case 13:
              accountInfo = _context6.sent;
              dispatch(receiveAccount([accountInfo]));
              accountInfoArray.push(accountInfo);
            case 16:
              _iteratorNormalCompletion = true;
              _context6.next = 9;
              break;
            case 19:
              _context6.next = 25;
              break;
            case 21:
              _context6.prev = 21;
              _context6.t0 = _context6['catch'](7);
              _didIteratorError = true;
              _iteratorError = _context6.t0;
            case 25:
              _context6.prev = 25;
              _context6.prev = 26;
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            case 28:
              _context6.prev = 28;
              if (!_didIteratorError) {
                _context6.next = 31;
                break;
              }
              throw _iteratorError;
            case 31:
              return _context6.finish(28);
            case 32:
              return _context6.finish(25);
            case 33:
              dispatch(subscribeToVerificationLevelUpdateEvents(accountInfoArray[0]));
            case 34:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
    }));
    return function (_x8) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var updateAccount = function updateAccount(loyaltyProduct) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      var _getState$user2, selectedAccountId, accounts, OMSId, currentAccount, payload, Amount, ProductId, response, text;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _getState$user2 = getState().user, selectedAccountId = _getState$user2.selectedAccountId, accounts = _getState$user2.accounts, OMSId = _getState$user2.userInfo.OMSId;
              currentAccount = accounts.find(function (account) {
                return selectedAccountId === account.AccountId;
              });
              payload = Object.assign({}, currentAccount, {
                LoyaltyProductId: 0,
                LoyaltyEnabled: false
              });
              if (loyaltyProduct) {
                Amount = loyaltyProduct.Amount, ProductId = loyaltyProduct.ProductId;
                payload.LoyaltyProductId = ProductId;

                // Never enable the loyalty token functionality if the balance is 0.
                if (Amount > 0) {
                  payload.LoyaltyEnabled = true;
                }
              }
              _context7.next = 6;
              return dispatch(callAPI('UpdateAccount', payload));
            case 6:
              response = _context7.sent;
              if (response.result) {
                text = loyaltyProduct ? 'Fee token successfully set' : 'Fee token successfully unset';
                dispatch(showSnack({
                  id: 'UpdateAccountSuccess',
                  text: text,
                  type: 'success'
                }));
                dispatch(getUserAccounts(OMSId));
              } else {
                dispatch(change('loyaltyTokenForm', 'loyaltyToken', currentAccount.LoyaltyProductId));
                dispatch(showSnack({
                  id: 'UpdateAccountError',
                  text: formatErrorText(response),
                  type: 'warning'
                }));
              }
            case 8:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));
    return function (_x9, _x10) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var selectAccount = function selectAccount(accountId, OMSId) {
  return function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch, getState) {
      var marginAccount, marginAccountId;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              dispatch(setAccount(accountId));
              if (config.global.privateMarketData) {
                dispatch(getOrders(accountId, OMSId));
              } else {
                dispatch(getOpenOrders(accountId, OMSId));
                dispatch(getInactiveOrders(accountId, OMSId));
              }
              dispatch(getAccountTrades(accountId, OMSId));
              dispatch(getOpenTradeReports(accountId, OMSId));
              dispatch(getDepositTickets(accountId, OMSId));
              dispatch(getWithdrawTickets(accountId, OMSId));
              dispatch(subscribeToWithdrawalTickets());
              dispatch(initOrderHistorySubscription(accountId, OMSId));
              dispatch(subscribeToOrderHistory());
              dispatch(getTransfers(accountId));
              dispatch(getIncomingTransfers(OMSId, accountId));
              dispatch(getTransferRequestsReceived(accountId, OMSId));
              dispatch(getTransferRequestsRequested(accountId, OMSId));
              dispatch(initMarketTradeSubscription());
              dispatch(subscribeToMarketTradeUpdated());
              dispatch(subscribeToAccountSettlements());
              AccountEventsSubscriptionService.subscribe(function (update) {
                return dispatch(UpdateAccount({
                  item: update,
                  index: getState().user.accounts.findIndex(function (i) {
                    return i.AccountId === accountId;
                  })
                }));
              });
              marginAccount = marginAccountSelector(getState());
              marginAccountId = marginAccount ? marginAccount.AccountId : null;
              if (accountId !== marginAccountId) {
                dispatch(subscribeToAccountPositionEvents(accountId));
                dispatch(getAccountPositions({
                  accountId: accountId,
                  OMSId: OMSId
                }));
              } else {
                dispatch(getMarginAccountState());
                dispatch(subscribeToMarginAccountPositionEvents(accountId, receiveMarginAccountPositionEvent));
              }
              dispatch(getAccountVerificationLevelConfig());
              dispatch(subscribeToDeposits());
            case 22:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this);
    }));
    return function (_x11, _x12) {
      return _ref8.apply(this, arguments);
    };
  }();
};
export var receiveAccount = function receiveAccount(payload) {
  return {
    type: RECEIVE_ACCOUNT,
    payload: payload
  };
};
export var setAccount = function setAccount(payload) {
  return {
    type: SET_ACCOUNT,
    payload: payload
  };
};
export var goToResetPasswordFormStep = function goToResetPasswordFormStep(step) {
  return function (dispatch) {
    return dispatch(change('resetPasswordRequest', 'step', step));
  };
};
export var goToBaseCurrencyFormStep = function goToBaseCurrencyFormStep(step) {
  return function (dispatch) {
    return dispatch(change('baseCurrencies', 'step', step));
  };
};
export var sendResetPasswordEmail = function sendResetPasswordEmail(UserName) {
  return function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch) {
      var Apex, response, snackbarPayload;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              Apex = void 0;
              _context9.prev = 1;
              Apex = getApex();
              _context9.next = 8;
              break;
            case 5:
              _context9.prev = 5;
              _context9.t0 = _context9['catch'](1);
              return _context9.abrupt('return', dispatch(showSnack({
                id: 'apexError',
                text: _context9.t0.message,
                type: 'warning'
              })));
            case 8:
              _context9.next = 10;
              return dispatch(callAPI('ResetPassword', {
                UserName: UserName
              }));
            case 10:
              response = _context9.sent;
              snackbarPayload = response.result ? {
                id: 'sendResetPasswordEmailSuccess',
                // context.t('Check Your Email For Reset Password Link');
                text: 'Check Your Email For Reset Password Link',
                type: 'success'
              } : {
                id: 'sendResetPasswordEmailError',
                text: formatErrorText(response),
                type: 'warning'
              };
              dispatch(showSnack(snackbarPayload));
              setTimeout(function () {
                return dispatch(logout());
              }, config.Snackbar.timeout);
            case 14:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this, [[1, 5]]);
    }));
    return function (_x13) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export var submitResetPasswordForm = function submitResetPasswordForm() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
      user = _getState2.user;
    dispatch(sendResetPasswordEmail(user.userInfo.UserName));
  };
};
export var setGoogleQrCode = function setGoogleQrCode(payload) {
  return {
    type: SET_GOOGLE_QRCODE,
    payload: payload
  };
};
export var clearGoogleQrCode = function clearGoogleQrCode() {
  return {
    type: CLEAR_GOOGLE_QRCODE
  };
};
export var getGoogleQrCode = function getGoogleQrCode() {
  return function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dispatch) {
      var qrCode;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return apex.connection.EnableGoogle2FA();
            case 2:
              qrCode = _context10.sent;
              dispatch(setGoogleQrCode(qrCode));
            case 4:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this);
    }));
    return function (_x14) {
      return _ref10.apply(this, arguments);
    };
  }();
};
export var disable2FA = function disable2FA(code) {
  return function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(dispatch, getState) {
      var userInfo, auth;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              userInfo = getState().user.userInfo;
              _context11.next = 3;
              return apex.connection.Disable2FA();
            case 3:
              _context11.next = 5;
              return apex.connection.Authenticate2FA({
                Code: code
              });
            case 5:
              auth = _context11.sent;
              if (auth.Authenticated) {
                dispatch(userInfoFetched(Object.assign({}, userInfo, {
                  Use2FA: false
                })));
                dispatch(closeModal(MODAL_TYPES.DISABLE_2FA));
                dispatch(showSnack({
                  id: 'DISABLE_2FA_SUCCESS',
                  // context.t('Two Factor Authenticated is disabled')
                  text: 'Two-Factor Authenticated is disabled',
                  type: 'success'
                }));
              } else {
                dispatch(showSnack({
                  id: 'DISABLE_2FA_ERROR',
                  // context.t('Code Rejected')
                  text: 'Code Rejected',
                  type: 'warning'
                }));
              }
            case 7:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this);
    }));
    return function (_x15, _x16) {
      return _ref11.apply(this, arguments);
    };
  }();
};
export var enable2FA = function enable2FA(code) {
  return function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(dispatch, getState) {
      var userInfo, auth;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              userInfo = getState().user.userInfo;
              _context12.next = 3;
              return apex.connection.Authenticate2FA({
                Code: code
              });
            case 3:
              auth = _context12.sent;
              if (auth.Authenticated) {
                dispatch(authSuccess(auth));
                dispatch(userInfoFetched(Object.assign({}, userInfo, {
                  Use2FA: true
                })));
                dispatch(closeModal(MODAL_TYPES.ENABLE_2FA));
                dispatch(clearGoogleQrCode());
                dispatch(showSnack({
                  id: 'ENABLE_2FA_SUCCESS',
                  // context.t('Two Factor Authenticated is enabled')
                  text: 'Two-Factor Authenticated is enabled',
                  type: 'success'
                }));
              } else {
                dispatch(showSnack({
                  id: 'ENABLE_2FA_ERROR',
                  // context.t('Code Rejected')
                  text: 'Code Rejected',
                  type: 'warning'
                }));
              }
            case 5:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this);
    }));
    return function (_x17, _x18) {
      return _ref12.apply(this, arguments);
    };
  }();
};
export var getGoogle2FARecoveryCode = function getGoogle2FARecoveryCode(code) {
  return function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(dispatch) {
      var response, recoveryCode;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return apex.connection.RPCPromise('GetGoogle2FARecoveryKey', {
                Code: code
              });
            case 2:
              response = _context13.sent;
              recoveryCode = JSON.parse(response.o);
              if (recoveryCode.Authenticated) {
                dispatch(change('google2FARecoveryKeyModal', 'recoveryKey', recoveryCode.RecoveryKey));
              } else {
                dispatch(showSnack({
                  id: 'RECOVERY_ERROR',
                  text: recoveryCode.errormsg,
                  type: 'warning'
                }));
              }
            case 5:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this);
    }));
    return function (_x19) {
      return _ref13.apply(this, arguments);
    };
  }();
};
export var resendVerificationEmail = function resendVerificationEmail(payload) {
  return function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(dispatch) {
      var Apex, response, snackbarPayload;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              Apex = void 0;
              _context14.prev = 1;
              Apex = getApex();
              _context14.next = 8;
              break;
            case 5:
              _context14.prev = 5;
              _context14.t0 = _context14['catch'](1);
              return _context14.abrupt('return', dispatch(showSnack({
                id: 'apexError',
                text: _context14.t0.message,
                type: 'warning'
              })));
            case 8:
              if (Apex.connection.ResendVerificationEmail) {
                _context14.next = 10;
                break;
              }
              return _context14.abrupt('return', dispatch(showSnack({
                id: 'resendVerificationEmailError',
                text: 'Feature Not Available.',
                type: 'warning'
              })));
            case 10:
              _context14.next = 12;
              return Apex.connection.ResendVerificationEmail(payload);
            case 12:
              response = _context14.sent;
              snackbarPayload = response.result ? {
                id: 'resendVerificationEmailSuccess',
                // context.t('Check Your Email For An Account Verification Email');
                text: 'Check Your Email For An Account Verification Email',
                type: 'success'
              } : {
                id: 'resendVerificationEmailError',
                text: formatErrorText(response),
                type: 'warning'
              };
              dispatch(showSnack(snackbarPayload));
            case 15:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this, [[1, 5]]);
    }));
    return function (_x20) {
      return _ref14.apply(this, arguments);
    };
  }();
};